<template>
    <td-dialog :title="$t(title)" :before-close="addOrgDialogClose" :visible.sync="addOrgAvailable" :close-on-click-modal="false" :close-on-press-escape="false" :width="modifyDialogWidth + 'px'">
        <div>
            <component
                v-bind:is="currentTabComponent"
                :editItem="editItem"
                :extendGroupFlg="extendGroupFlg"
                :regularCheckID="regularCheckID"
                :tabOptions="tabOptions"
                :selectType="selectType"
                :isAddData="true"
                :isAllowOrgIdDictDisabled="isAllowOrgIdDictDisabled"
                @addOrgDialogClose="addOrgDialogClose"
                @beforeSubmitForm="beforeSubmitForm"
                @validateSubmitFormFail="validateSubmitFormFail"
                @typeSelectChange="typeSelectChange"
                ref="addOrgComponent"
            >
            </component>
        </div>
        <span slot="footer">
            <td-button type="primary" :loading="loading" @click="submitForm">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import orgApi from './../assets/api.js';
export default {
    name: 'tableIndex',
    props: {
        /* 编辑时，表单域标签的宽度设置 */
        modifyDevInfoFormLabelWidth: {
            type: [Number, String],
            default: function() {
                return 100;
            }
        },
        /* 编辑dialog宽度设置 */
        modifyDialogWidth: {
            type: [Number, String],
            default: function() {
                return 650;
            }
        },
        title: {
            type: [String, Number]
        },
        addOrgAvailable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        editItem: {
            trpe: Object,
            default: function() {
                return null;
            }
        },
        // 组标签
        extendGroupFlg: {
            trpe: Object,
            default: function() {
                return null;
            }
        },
        // 添加页面paneName数据
        addPaneName: {
            type: Object,
            default: function() {
                return null;
            }
        },
        // 类型信息数据
        tabOptions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 当前选中的组织类型 */
        selectType: {
            type: Number,
            default: function() {
                return 0;
            }
        },
        isAllowOrgIdDictDisabled: {
            type: Boolean,
            default: function() {
                return false;
            }
        }
    },

    data() {
        return {
            hight: 100,
            loading: false
        };
    },

    computed: {
        currentTabComponent: function() {
            return this.addPaneName;
        }
    },

    methods: {
        // 类型下拉框change时间
        typeSelectChange(param) {
            if (this.tabOptions != null && this.tabOptions != '') {
                this.viewExtendGroupByTypeId(param);
                // 切换tab页面
                for (let i = 0; i < this.tabOptions.length; i++) {
                    if (this.tabOptions[i].id === param) {
                        this.selectType = param;
                        this.paneName =
                            this.tabOptions[i].sDlgPageName == null || this.tabOptions[i].sDlgPageName == '' || this.tabOptions[i].sDlgPageName == undefined
                                ? 'TdOrgInfo'
                                : this.tabOptions[i].sDlgPageName;
                    }
                }
            }
        },

        // 根据类型显示对应的扩展组
        viewExtendGroupByTypeId(orgTypeId) {
            for (let i = 0; i < this.tabOptions.length; i++) {
                if (this.tabOptions[i].id === orgTypeId) {
                    this.extendGroupFlg = this.tabOptions[i].sGroupFlg;
                }
            }
        },

        // 提交数据
        submitForm() {
            this.loading = true;
            this.$refs.addOrgComponent.submitForm();
        },
        // 表单验证失败
        validateSubmitFormFail() {
            this.loading = false;
        },
        // 提交数据
        beforeSubmitForm(content) {
            if (content === null || content === '' || content === undefined) {
                this.$message({ type: 'error', showClose: true, message: this.$t('pgMessage.CALLBACK_PARAM_NULL') });
            }

            orgApi.insertOrg(JSON.stringify(content), response => {
                this.loading = false;
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('orgApi.insertOrg', response);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                this.$emit('reciveOrgInfoFromDialog', response.data.content, this.editBaseOrg);
                this.addOrgDialogClose();
            });
        },

        // 取消
        cancel() {
            this.$emit('addOrgDialogClose');
        },

        // 关闭窗口之前需要调用的方法
        addOrgDialogClose() {
            this.$emit('addOrgDialogClose');
            this.editItem = null;
            this.addPaneName = null;
        }
    }
};
</script>

<style scoped>
.el-tabs__header {
    margin-bottom: 0px;
}
</style>
